import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ServiceOptionsPage from './pages/ServiceOptionsPage';
import AddServicePage from './pages/AddServicePage';
import SummaryPage from './pages/SummaryPage';

interface SpecialViewProps {
  storeId: string;
  externalIdentity: string;
  cartId: string;
  productId: string;
}

export const SpecialOrderViewRoutes: React.FC<SpecialViewProps> = ({ storeId, externalIdentity, cartId, productId }) => (
  <Routes>
    <Route path="/" element={<ServiceOptionsPage storeId={storeId} externalIdentity={externalIdentity} cartId={cartId} />} />
    <Route path="/services/details/:serviceId" element={<AddServicePage />} />
    <Route path="/summary" element={<SummaryPage externalIdentity={externalIdentity} cartId={cartId} productId={productId} storeId={storeId} />} />
  </Routes>
);
